import { IUserAccountGeneral } from '../../types';

export const defaultValuesUserForm = (current: Partial<IUserAccountGeneral> | undefined) => ({
  name: current?.name || '',
  email: current?.email || '',
  phone: current?.phone || '',
  rol: current?.rol?.id || '',
  password: current?.password || '',
  indicatorPhone: current?.indicatorPhone || '+57',
  branch: current?.branchSelected || false,
  isShift: current?.isShift || false
});
